import QtdModulo from '../../ModulosCrefito/QtdModulo'
import TOPerfilAssistencia from '../../ModulosCrefito/ModulosTO/TOPerfilAssistencia'
import TOregistroProntuario from '../../ModulosCrefito/ModulosTO/TOregistroProntuario'
import TOoutrosDados from '../../ModulosCrefito/ModulosTO/TOoutrosDados'
import TOorientacoes from '../../ModulosCrefito/ModulosTO/TOorientacoes'
import TOresponsavelFisc from '../../ModulosCrefito/ModulosTO/TOresponsavelFisc'
import TOservicoNaUnidade from '../../ModulosCrefito/ModulosTO/TOservicoNaUnidade'
import TOprofissionaisNoEstabelecimento from '../../ModulosCrefito/ModulosTO/TOprofissionaisNoEstabelecimento'
import TOparametrosAssistenciais from '../../ModulosCrefito/ModulosTO/TOparametrosAssistenciais'
import TOrecursoEstrutura from '../../ModulosCrefito/ModulosTO/TOrecursoEstrutura'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import TOpessoaNaoHabilitada from '../../ModulosCrefito/ModulosTO/TOpessoaNaoHabilitada'
import React from 'react'

const Ilpis = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="PESSOA NÃO HABILITADA A EXERCER ATIVIDADES PRIVATIVAS DA TO" modulo="topessoanaohabilitada" />
            <TOpessoaNaoHabilitada modulo="topessoanaohabilitada" />
            <QtdModulo texto="RESPONSÁVEL PELO RECEBIMENTO DA FISCALIZAÇÃO" modulo="toresponsavelfisc" />
            <TOresponsavelFisc modulo="toresponsavelfisc" />
            <QtdModulo texto="PROFISSIONAIS TERAPEUTAS OCUPACIONAIS" modulo="toprofissionaisnoestabelecimento" />
            <TOprofissionaisNoEstabelecimento modulo="toprofissionaisnoestabelecimento" />
            <QtdModulo texto="PARÂMETROS ASSISTENCIAIS" modulo="toparametrosassistenciais" />
            <TOparametrosAssistenciais modulo="toparametrosassistenciais" />
            <QtdModulo texto="PERFIL DA ASSISTÊNCIA DE TERAPIA OCUPACIONAL" modulo="toperfilassistencia" />
            <TOPerfilAssistencia modulo="toperfilassistencia" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="toregistroprontuario" />
            <TOregistroProntuario modulo="toregistroprontuario" />
            <QtdModulo texto="SERVIÇOS NA UNIDADE" modulo="toserviconaunidade" />
            <TOservicoNaUnidade modulo="toserviconaunidade" />
            <QtdModulo texto="SETORES DA ASSISTÊNCIA - RECURSOS E ESTRUTA " modulo="torecursoest" />
            <TOrecursoEstrutura modulo="torecursoest" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="tooutrosDados" />
            <TOoutrosDados modulo="tooutrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/RECOMENDAÇÕES/NOTIFICAÇÕES" modulo="toorientacoes" />
            <TOorientacoes modulo="toorientacoes" />
        </>
    )
}

export default Ilpis